import axios from 'axios';
import React, { useState } from 'react';
import endPoint from '../../redux/EndPoint/endpoint';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const SellerForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate()

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoader(true);
            const res = await axios.post(endPoint.SellerForgotPassword, { email });
            navigate("/SellerResetPassword");
            toast.success(res.data?.message || "OTP sent to your email");
        } catch (error) {
            toast.error("Seller with this email not found.")
        }
        finally {
            setLoader(false);
        }
    };


    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-50 via-blue-200 to-white py-10">

            <div className="bg-white rounded-2xl shadow-lg max-w-md p-8 space-y-8 sm:w-full w-[90%]">
                <div className="text-center">
                    <h2 className="text-3xl font-bold text-gray-800">Forgot Password</h2>
                    <p className="text-gray-600 mt-1">Enter your email to reset your password</p>
                </div>
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="relative">
                        <label className="block text-gray-700 text-sm font-medium">
                            Email Address
                        </label>
                        <div className="relative mt-2">
                            <input
                                type="email"
                                required
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full pl-4 pr-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-indigo-500"
                                placeholder="Enter your email address"
                            />
                        </div>
                    </div>
                    <div className="flex justify-center">
                        <button
                            type="submit"
                            className="w-full bg-indigo-600 text-white py-2 rounded-lg hover:bg-indigo-700 transition duration-300"
                        >
                            {loader ? "Please wait..." : "Reset Password"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
export default SellerForgotPassword;